import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.array.from";
import _regeneratorRuntime from "/codebuild/output/src3198408216/src/www-public/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/codebuild/output/src3198408216/src/www-public/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/codebuild/output/src3198408216/src/www-public/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es7.object.entries";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.for-each";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var U = function () {
  function t() {}

  return t.prototype.getApplicationContext = function () {
    return {
      versionName: this.versionName,
      language: q(),
      platform: "Web",
      os: void 0,
      deviceModel: void 0
    };
  }, t;
}(),
    q = function q() {
  return typeof navigator < "u" && (navigator.languages && navigator.languages[0] || navigator.language) || "";
},
    B = function () {
  function t() {
    this.queue = [];
  }

  return t.prototype.logEvent = function (e) {
    this.receiver ? this.receiver(e) : this.queue.length < 512 && this.queue.push(e);
  }, t.prototype.setEventReceiver = function (e) {
    this.receiver = e, this.queue.length > 0 && (this.queue.forEach(function (n) {
      e(n);
    }), this.queue = []);
  }, t;
}(),
    _p = function p() {
  return _p = Object.assign || function (e) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];

      for (var c in n) {
        Object.prototype.hasOwnProperty.call(n, c) && (e[c] = n[c]);
      }
    }

    return e;
  }, _p.apply(this, arguments);
};

function A(t) {
  var e = typeof Symbol == "function" && Symbol.iterator,
      n = e && t[e],
      r = 0;
  if (n) return n.call(t);
  if (t && typeof t.length == "number") return {
    next: function next() {
      return t && r >= t.length && (t = void 0), {
        value: t && t[r++],
        done: !t
      };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function C(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n) return t;
  var r = n.call(t),
      o,
      c = [],
      y;

  try {
    for (; (e === void 0 || e-- > 0) && !(o = r.next()).done;) {
      c.push(o.value);
    }
  } catch (l) {
    y = {
      error: l
    };
  } finally {
    try {
      o && !o.done && (n = r["return"]) && n.call(r);
    } finally {
      if (y) throw y.error;
    }
  }

  return c;
}

var x = function x(t, e) {
  var n,
      r,
      o = ["string", "number", "boolean", "undefined"],
      c = typeof t,
      y = typeof e;
  if (c !== y) return !1;

  try {
    for (var l = A(o), f = l.next(); !f.done; f = l.next()) {
      var a = f.value;
      if (a === c) return t === e;
    }
  } catch (m) {
    n = {
      error: m
    };
  } finally {
    try {
      f && !f.done && (r = l["return"]) && r.call(l);
    } finally {
      if (n) throw n.error;
    }
  }

  if (t == null && e == null) return !0;
  if (t == null || e == null || t.length !== e.length) return !1;
  var i = Array.isArray(t),
      s = Array.isArray(e);
  if (i !== s) return !1;

  if (i && s) {
    for (var u = 0; u < t.length; u++) {
      if (!x(t[u], e[u])) return !1;
    }
  } else {
    var g = Object.keys(t).sort(),
        v = Object.keys(e).sort();
    if (!x(g, v)) return !1;
    var d = !0;
    return Object.keys(t).forEach(function (m) {
      x(t[m], e[m]) || (d = !1);
    }), d;
  }

  return !0;
},
    N = "$set",
    T = "$unset",
    $ = "$clearAll";

Object.entries || (Object.entries = function (t) {
  for (var e = Object.keys(t), n = e.length, r = new Array(n); n--;) {
    r[n] = [e[n], t[e[n]]];
  }

  return r;
});

var M = function () {
  function t() {
    this.identity = {
      userProperties: {}
    }, this.listeners = new Set();
  }

  return t.prototype.editIdentity = function () {
    var e = this,
        n = _p({}, this.identity.userProperties),
        r = _p(_p({}, this.identity), {
      userProperties: n
    });

    return {
      setUserId: function setUserId(o) {
        return r.userId = o, this;
      },
      setDeviceId: function setDeviceId(o) {
        return r.deviceId = o, this;
      },
      setUserProperties: function setUserProperties(o) {
        return r.userProperties = o, this;
      },
      setOptOut: function setOptOut(o) {
        return r.optOut = o, this;
      },
      updateUserProperties: function updateUserProperties(o) {
        var c,
            y,
            l,
            f,
            a,
            i,
            s = r.userProperties || {};

        try {
          for (var u = A(Object.entries(o)), g = u.next(); !g.done; g = u.next()) {
            var v = C(g.value, 2),
                d = v[0],
                m = v[1];

            switch (d) {
              case N:
                try {
                  for (var S = (l = void 0, A(Object.entries(m))), h = S.next(); !h.done; h = S.next()) {
                    var b = C(h.value, 2),
                        D = b[0],
                        L = b[1];
                    s[D] = L;
                  }
                } catch (w) {
                  l = {
                    error: w
                  };
                } finally {
                  try {
                    h && !h.done && (f = S["return"]) && f.call(S);
                  } finally {
                    if (l) throw l.error;
                  }
                }

                break;

              case T:
                try {
                  for (var E = (a = void 0, A(Object.keys(m))), I = E.next(); !I.done; I = E.next()) {
                    var D = I.value;
                    delete s[D];
                  }
                } catch (w) {
                  a = {
                    error: w
                  };
                } finally {
                  try {
                    I && !I.done && (i = E["return"]) && i.call(E);
                  } finally {
                    if (a) throw a.error;
                  }
                }

                break;

              case $:
                s = {};
                break;
            }
          }
        } catch (w) {
          c = {
            error: w
          };
        } finally {
          try {
            g && !g.done && (y = u["return"]) && y.call(u);
          } finally {
            if (c) throw c.error;
          }
        }

        return r.userProperties = s, this;
      },
      commit: function commit() {
        return e.setIdentity(r), this;
      }
    };
  }, t.prototype.getIdentity = function () {
    return _p({}, this.identity);
  }, t.prototype.setIdentity = function (e) {
    var n = _p({}, this.identity);

    this.identity = _p({}, e), x(n, this.identity) || this.listeners.forEach(function (r) {
      r(e);
    });
  }, t.prototype.addIdentityListener = function (e) {
    this.listeners.add(e);
  }, t.prototype.removeIdentityListener = function (e) {
    this.listeners["delete"](e);
  }, t;
}(),
    P = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : self,
    O = function () {
  function t() {
    this.identityStore = new M(), this.eventBridge = new B(), this.applicationContextProvider = new U();
  }

  return t.getInstance = function (e) {
    return P.analyticsConnectorInstances || (P.analyticsConnectorInstances = {}), P.analyticsConnectorInstances[e] || (P.analyticsConnectorInstances[e] = new t()), P.analyticsConnectorInstances[e];
  }, t;
}();

var R = ["boot"];
var Z = "$default_instance";

function K(t) {
  var o, c, y, l;
  var e = window.engagement,
      n = {
    _q: (o = e == null ? void 0 : e._q) != null ? o : [],
    _configuration: {
      apiKey: (y = (c = e == null ? void 0 : e._configuration) == null ? void 0 : c.apiKey) != null ? y : "",
      serverUrl: (l = e == null ? void 0 : e._configuration) == null ? void 0 : l.serverUrl
    },
    _sentry: void 0,
    init: function init(f, a) {
      var i, s, u;
      n._configuration = _objectSpread(_objectSpread({
        apiKey: f
      }, a), {}, {
        options: _objectSpread({}, a == null ? void 0 : a.options)
      }), (s = (i = n._configuration) == null ? void 0 : i.options) != null && s.logger && n._configuration.options.logger.enable((u = n._configuration.options.logLevel) != null ? u : 0), t();
    },
    plugin: function plugin(f) {
      var a = n.init;
      return {
        name: "@amplitude/engagement-browser",
        type: "enrichment",
        setup: function setup(i, s) {
          return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var v, u, g;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    u = (v = i.instanceName) != null ? v : Z, g = O.getInstance(u).identityStore;
                    a(i.apiKey, _objectSpread(_objectSpread({
                      options: {
                        logLevel: i.logLevel
                      }
                    }, f), {}, {
                      serverZone: i.serverZone
                    }));
                    _context.next = 4;
                    return window.engagement.boot({
                      user: function user() {
                        var d = g.getIdentity();
                        return {
                          user_id: s.getUserId(),
                          device_id: s.getDeviceId(),
                          user_properties: d.userProperties,
                          getSessionId: s.getSessionId
                        };
                      },
                      integrations: [{
                        track: function track(d) {
                          s.track(d);
                        }
                      }]
                    });

                  case 4:
                    g.addIdentityListener(function (d) {
                      window.engagement._setUserProperties(d.userProperties);
                    });

                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }))();
        },
        execute: function execute(i) {
          return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    return _context2.abrupt("return", (window.engagement.forwardEvent(i), i));

                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }))();
        }
      };
    }
  },
      r = n;
  return new Proxy(n, {
    get: function get(f, a) {
      if (a in r) return r[a];
      if (a !== "then") return a === "gs" ? new Proxy({}, {
        get: function get(i, s) {
          return function () {
            var u = Array.from(arguments),
                g = "".concat(a, ".").concat(s);
            u.unshift(g), n._q.push(u);
          };
        }
      }) : R.includes(a) ? function () {
        var i = Array.prototype.slice.call(arguments);
        return new Promise(function (s, u) {
          i.unshift(a, s, u), n._q.push(i);
        });
      } : function () {
        var i = Array.prototype.slice.call(arguments);
        i.unshift(a), n._q.push(i);
      };
    }
  });
}

var _ = function _() {
  function t(e) {
    var _iterator = _createForOfIteratorHelper(e),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var n = _step.value;
        var r = document.createElement("script");
        r.src = n, r.id = "engagement-sdk-bundle";
        var o = document.querySelector("[nonce]");
        o && r.setAttribute("nonce", o.nonce || o.getAttribute("nonce")), document.getElementsByTagName("head")[0].appendChild(r);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return K(function () {
    return t(["https://cdn.amplitude.com/engagement-browser/prod/index.min.js.gz"]);
  });
};

window.engagement = _();

var k = _();

window.engagement = k;
var J = k.init,
    Q = k.plugin;
export { J as init, Q as plugin };